// extracted by mini-css-extract-plugin
module.exports = {"section":"UniversalIntegrationsActions_section__I8Zmm","actions":"UniversalIntegrationsActions_actions__d7p0s","button":"UniversalIntegrationsActions_button__lM9Za"};